import { ReactNode } from 'react';
import { Palette } from '@mui/material';
import { CheckCircleSolid, Circle, CircleSolid, ExclamationCircleSolid, Sync } from '@assets/svgs';
import { IMenuItem, MenuItemType } from '@components/menu';
import { InsuredLocationStatus } from '@models/customer';

export enum LocationTitle {
  EditLocation = 'Edit Location',
  AddProxyLocation = 'Add Proxy Location',
  ReloadHazards = 'Reload Hazards',
}

export const locationActionMenu: IMenuItem[] = [
  {
    type: MenuItemType.Default,
    text: LocationTitle.EditLocation,
  },
  {
    type: MenuItemType.Default,
    text: LocationTitle.AddProxyLocation,
    isDisabled: (locationStatus) =>
      ![InsuredLocationStatus.Approved, InsuredLocationStatus.Invalid].includes(locationStatus),
  },
  {
    type: MenuItemType.Default,
    text: LocationTitle.ReloadHazards,
  },
];

export enum PanelMode {
  View = 'View',
  Edit = 'Edit',
  Minimized = 'Minimized',
}

export enum PanelStatus {
  Idle = 'idle',
  Complete = 'complete',
  Unfinished = 'unfinished',
  Saving = 'saving',
  Valid = 'valid',
  Review = 'review',
  BindIncomplete = 'bindIncomplete',
}

interface Option {
  panel: string;
  icon: string;
}

type IColor = {
  [key in PanelStatus]: Option;
};

type IIcon = {
  [key in PanelStatus]: ReactNode;
};

export function getPanelColor(palette: Palette): IColor {
  return {
    [PanelStatus.Idle]: {
      panel: palette.text.disabled,
      icon: palette.text.disabled,
    },
    [PanelStatus.Complete]: {
      panel: palette.success.light,
      icon: palette.success.light,
    },
    [PanelStatus.Unfinished]: {
      panel: palette.error.light,
      icon: palette.error.light,
    },
    [PanelStatus.Saving]: {
      panel: palette.text.disabled,
      icon: palette.success.light,
    },
    [PanelStatus.Valid]: {
      panel: palette.success.light,
      icon: palette.success.light,
    },
    [PanelStatus.Review]: {
      panel: palette.theme === 'lio' ? palette.secondary.light : palette.other.highlight,
      icon: palette.theme === 'lio' ? palette.secondary.light : palette.other.highlight,
    },
    [PanelStatus.BindIncomplete]: {
      panel: palette.other.bindIncomplete,
      icon: palette.other.bindIncomplete,
    },
  };
}

export const icon: IIcon = {
  [PanelStatus.Idle]: <Circle />,
  [PanelStatus.Complete]: <CheckCircleSolid />,
  [PanelStatus.Unfinished]: <ExclamationCircleSolid />,
  [PanelStatus.Saving]: <Sync />,
  [PanelStatus.Valid]: <CircleSolid />,
  [PanelStatus.Review]: <Circle />,
  [PanelStatus.BindIncomplete]: <CircleSolid />,
};
